import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { BaseTexture, Container, Graphics, Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
import tools from "tools";
import Particules from "../levels/particules";
import Stars from "../levels/stars";
import ColorThief from 'colorthief';
export default class playerBubble extends Container {
  constructor(path) {
    super();
    this.wiggleAnim = this.wiggleAnim.bind(this);
    this.wiggle = this.wiggle.bind(this);
    this.path = path;
    this.pos = new Point();
    this.build();
  }
  build() {
    let bubble = new Sprite(assets.textures.transbubble.texture);
    bubble.anchor.set(.5);
    this._picto = new Sprite(new Texture(new BaseTexture(this.path)));
    this._picto.width = bubble.width;
    this._picto.height = bubble.height;
    this._picto.anchor.set(.5);
    this.addChild(this._picto);
    this.colorThief = new ColorThief();
    let __mask = new Graphics();
    __mask.beginFill(0xff0000);
    __mask.drawCircle(0, 0, bubble.width / 2 - 2);
    __mask.endFill();
    this._picto.mask = __mask;
    this.addChild(__mask);
    this.addChild(bubble);
    this.scale.set(0);
    this.visible = false;
  }
  set picto(texture) {
    this._picto.texture = texture;
  }
  show(x, y) {
    this.pos.x = x;
    this.pos.y = y;
    this.visible = true;
    this.scaleTween && this.scaleTween.kill();
    this.scaleTween = gsap.to(this.scale, {
      duration: .3,
      x: 1.8,
      y: 1.8,
      ease: "back.out(3)",
      onComplete: () => {
        this.wiggle(2, .05);
      }
    });

    // this.mainColor = this.colorThief.getColor(this._picto.texture.baseTexture.resource.source);
    // this.mainColor = tools.rgbToHex(
    //     this.mainColor[0],
    //     this.mainColor[1],
    //     this.mainColor[2]
    // )

    this.colors = [];
    if (this._picto.texture.baseTexture.resource.width > 10) {
      this.colors = this.colorThief.getPalette(this._picto.texture.baseTexture.resource.source);
    }
    let colorArr = [];
    for (let i = 0; i < this.colors.length; i++) {
      colorArr.push("0x" + tools.rgbToHex(this.colors[i][0], this.colors[i][1], this.colors[i][2]));
    }
    colorArr.push("0xffffff");
    colorArr.push("0xffffff");
    colorArr.push("0xffffff");
    colorArr.push("0xffffff");
    colorArr.push("0xffffff");
    colorArr.push("0xffffff");
    colorArr.push("0xffffff");
    colorArr.push("0xffffff");
    this.particules = new Particules(0xffffff, {
      x: x,
      y: y
    }, 200, config.particulesContainer, 11, 1.1, colorArr);
    this.particules.force = new Point(1.038, 1.058);
    this.particules.gravity = new Point(0, .000173);
  }
  wiggle(range, time) {
    this.wiggleAnim(range, time);
  }
  wiggleAnim(range, time) {
    let x = tools.range(-range, range) + this.pos.x;
    let y = tools.range(-range, range) + this.pos.y;
    this.wiggleTween && this.wiggleTween.kill();
    this.wiggleTween = gsap.to(this, {
      duration: time,
      x: x,
      y: y,
      onComplete: () => {
        this.wiggleAnim(range, time);
      }
    });
  }
  explod(callback) {
    this.scaleTween && this.scaleTween.kill();
    this.scaleTween = gsap.to(this.scale, {
      duration: .3,
      x: 3,
      y: 3,
      ease: "power4.in",
      onComplete: () => {
        this.visible = false;
        this.scale.set(0);
        callback && callback();
        this.particules && this.particules.animate();
      }
    });
  }
}
